export const ERROR_MESSAGES_TRANSLATIONS = {
  "The given data was invalid.": "Die angegebenen Daten sind ungültig.",  // The data provided is invalid.
  "Unable to find customer from relationship.": "Einer der Partner aus der gemeinschaft konnte nicht gefunden werden in Kundendaten."
};